<template>
  <div>
    <div class="search-x">
      <el-button
        class="part-right"
        style="margin-bottom:10px;"
        v-auth="'sa_item_page'"
        type="primary"
        @click="toAdd(1)"
        >添加一级服务类别</el-button
      >
    </div>
    <div class="cont-x">
      <div class="table-x" ref="tableBox">
        <el-table 
          v-loading="loading" 
          :data="treeList" 
          :height="tableHeight()"
          row-key="id"
          :cell-style="cellStyle"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          border 
          class="mb20">
          <el-table-column label="展开/收起" align="center" width="100"></el-table-column>
          <el-table-column prop="name" align="center" label="分类名称">
          </el-table-column>
          <el-table-column prop="code" align="center" label="编码">
          </el-table-column>
          <el-table-column align="center" label="分类等级">
            <template slot-scope="scope">
              {{ scope.row.children ? "一级分类" : "二级分类" }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="toDetail(scope.row)"
                >查看</el-button
              >
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="toEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="handleDel(scope.row)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.children"
                size="middle"
                class="mb10"
                type="text"
                @click="toAdd(2,scope.row)"
                >添加分类</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ServiceEdit  ref="edit" :show="showEdit" :type="showType" :current="currentId" :detail="editItem" @editReceive="getReceive"  @reload="getData" />
  </div>
</template>

<script>
import ServiceEdit from './components/serviceEdit.vue'
export default {
  name: "serviceTypeList",
  components: {
    ServiceEdit
  },
  data() {
    return {
      loading: false,
      treeList: [],
      showEdit: false,
      showType: 0, // 右侧列表显示类型 1-新建一级 2-新建二级 3-编辑 5-查看
      currentId: 0,
      editItem: {}
    };
  },
  methods: {
    tableHeight() {
      return Number(document.body.offsetHeight - 218)
    },
    getReceive(data) {
      this[data.key] = data.value
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
      if (columnIndex < 1 && !row.children) {
        return {
          'border-right': 'none',
        }
      }
    },
    /**
     * 添加
     */
    toAdd(type,item) {
      this.showEdit = true;
      this.showType = type;
      if(type == 2) this.currentId = item.id
      this.$refs.edit.clearBoxData();
    },
    /**
     * 获取树形控件数据
     */
    getData() {
      this.loading = true
      this.axios
        .get(this.getApiUrl("serviceTypeTree"), {})
        .then((res) => {
          if (res.code === 1) {
            this.treeList = res.data;
          } else {
            this.$message.warning(res.msg);
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err);
        });
    },
    /**
     * to true false
     */
    toEdit(item) {
      this.$refs.edit.clearBoxData();
      let param = item;
      Object.keys(param).forEach((item) => {
        if (param[item] === "YES") param[item] = true;
        if (param[item] === "NO") param[item] = false;
      });
      if(item.children) this.showType = 3;
      else this.showType = 4;
      this.editItem = JSON.parse(JSON.stringify(param))
      this.showEdit = true;
      this.currentId = item.parentId
    },
    toDetail(item) {
      if(item.children) this.showType = 5;
      else this.showType = 6;
      this.editItem = JSON.parse(JSON.stringify(item))
      this.showEdit = true;
      this.currentId = item.parentId
    },
    handleDel(row) {
      if(row.isConnect) {
        this.delTips()
      }else{
        this.del(row.id)
      }
    },
    /**
     * 删除确认弹窗
     * @param {Number} id 要删除的数据的id
     */
    async del(id) {
      this.$confirm("确认删除当前服务类别?", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteAction(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    delTips() {
      this.$alert('该类别与服务项目存在关联关系，无法删除', '删除确认', {
          confirmButtonText: '取消',
          callback: action => {}
        });
    },
    /**
     * 删除操作
     */
    async deleteAction(id) {
      const res = await this.axios.post(
        this.getApiUrl("serviceTypeDelete"),
        { id },
        {
          toJSON: true,
        }
      );
      if (res.code === 1) {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.showType = 0;
        this.getData()
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    },
  },
  created() {
    this.$root.breadList = [
      { name: "基础数据", link: "" },
      { name: "服务类别管理", link: "" },
    ];
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import '../../../src/assets/css/color.scss';

// 修改图标
::v-deep .el-icon-arrow-right:before {
  // content: "+";
  display: inline-block;
  width: 50px;
  color: $theme;
  font-size: 14px;
  font-weight: 700px;
  text-align: center;
}
::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  content: "展开";
}

// 去掉小图标的旋转效果
::v-deep [class*="el-table__row--level"] .el-table__expand-icon {
  width: 60px;
  transform: rotate(0);
}

// 修改展开之后的图标
::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before {
  content: "收起";
}


</style>
